/**
 * Variant
 *
 * @module variant
 */
const component = {

    /**
     * Init component
     * 
     * @return {boolean|undefined}
     */
	init: () => {

        /**
         * Variant module api
         * 
         * @global
         */
    	window.theme.variant = component;
	},

    /**
     * Trigger variant change with data
     * 
     * @public
     * @method
     * @name triggerVariantChange
     * @param {integer} variantId Variant id.
     * @param {object} product Product data.
     * @fires variant-change
     * @returns {object} Event variant-change.
     */
    triggerVariantChange: (variantId, product) => {
        let event = new CustomEvent('variant-change', {'detail': {
            variantId: variantId,
            variant: component.getVariant(variantId, product),
            product: product
        }});

        window.dispatchEvent(event);

        return event;
    },

    /**
     * Get variant data
     * 
     * @public
     * @method
     * @name getVariant
     * @param {integer} variantId Variant id.
     * @param {object} product Product data.
     * @returns {object} Variant data.
     */
    getVariant: (variantId, product) => {

        let variantData = null;

        product.variants.forEach(variant => {

            if (variant.id == variantId)
                variantData = variant;
        });

        return variantData;
    }
};

export default component;
